const queryParams = ({ page, where, relationships, orderBy, sortedBy }) => {
  var queryParams = {
    page: page ? page : 1
  };

  try {
    if (Array.isArray(relationships)) {
      queryParams.with = relationships.join(";");
    }
  } catch (error) {
    console.error("Error parsing relationship params", error);
  }

  try {
    const search = [];
    const searchFields = [];
    if (Array.isArray(where)) {
      where.forEach(w => {
        if (w.length == 3 && w[2]) {
          search.push(`${w[0]}:${w[2]}`);
          searchFields.push(`${w[0]}:${w[1]}`);
        } else if (w.length == 2 && w[1]) {
          search.push(`${w[0]}:${w[1]}`);
          searchFields.push(`${w[0]}:=`);
        }
      });
      queryParams.search = search.join(";");
      queryParams.searchFields = searchFields.join(";");
      queryParams.searchJoin = "and";
    }
  } catch (error) {
    console.error("Error parsing where params", error);
  }

  try {
    if (orderBy) {
      queryParams.orderBy = orderBy;
      queryParams.sortedBy = "asc";
    }

    if (orderBy && ["asc", "desc"].indexOf(sortedBy) !== -1) {
      queryParams.sortedBy = sortedBy;
    }
  } catch (error) {
    console.error("Error parsing relationship params", error);
  }

  return queryParams;
};

export default queryParams;
